import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "d-flex align-center justify-space-between" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "d-flex align-center justify-space-between" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "d-flex align-center justify-space-between" }
const _hoisted_8 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_list, null, {
      default: _withCtx(() => [
        (_ctx.shouldShowCalendar)
          ? (_openBlock(), _createBlock(_component_v_list_item, {
              key: 0,
              to: `/event-calender`
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _cache[1] || (_cache[1] = _createElementVNode("div", null, " イベントカレンダー ", -1)),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createTextVNode("mdi-chevron-right", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_divider),
        (_ctx.shouldShowNursery)
          ? (_openBlock(), _createBlock(_component_v_list_item, {
              key: 1,
              to: `/change-nursery`
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _cache[3] || (_cache[3] = _createElementVNode("div", null, " 園の切り替え ", -1)),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode("mdi-chevron-right", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_divider),
        (_ctx.shouldShowNotification)
          ? (_openBlock(), _createBlock(_component_v_list_item, {
              key: 2,
              to: `/change-notification`
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _cache[5] || (_cache[5] = _createElementVNode("div", null, " 通知の設定 ", -1)),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createTextVNode("mdi-chevron-right", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_divider),
        (_ctx.shouldShowLogout)
          ? (_openBlock(), _createBlock(_component_v_list_item, {
              key: 3,
              onClick: _ctx.logout
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", null, " ログアウト ", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode("mdi-chevron-right", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_divider)
      ]),
      _: 1
    })
  ]))
}